import React, { useState } from 'react';
import './Papers.css';

function Papers() {
  const [papers] = useState([
    {
      _id: 'internship-1',
      title: 'Monster Energy Industry Analysis & Strategic Recommendations',
      filename: 'InternshipFinal_Lukin.pdf',
      path: '/InternshipFinal_Lukin.pdf',
      uploadDate: new Date().toISOString(),
      isSample: false
    }
  ]);

  return (
    <main className="papers-page">
      <h1>My Papers & Projects</h1>
      <p className="page-description">
        This is where I showcase my academic work and research papers. 
        Here you can view and read my research documents directly on the site.
      </p>

      <div className="papers-viewer-section">
        {papers.length === 0 ? (
          <p className="no-content">No papers available.</p>
        ) : (
          <div className="papers-list">
            {papers.map((paper) => (
              <div key={paper._id} className="paper-viewer-item">
                <div className="paper-header">
                  <h2>{paper.title}</h2>
                  {paper.isSample && <span className="sample-badge">SAMPLE</span>}
                </div>
                <p className="paper-date">
                  Uploaded: {new Date(paper.uploadDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </p>
                <div className="pdf-viewer-container">
                  <embed
                    src={paper.path}
                    type="application/pdf"
                    title={paper.title}
                    className="pdf-viewer"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}

export default Papers;
